module.exports = __webpack_public_path__ + "static/img/home_advantage_bg_1.14155da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_advantage_bg_1.png
// module id = eXSP
// module chunks = 0